import React, { useEffect, useCallback } from 'react';
import useService from '../hooks/useService';
import link from '../lib/services/link';
import { RouteComponentProps } from 'react-router';
import { LinearProgress, Typography } from '@mui/material';
import UPPage from '../components/UPPage';
import { useTranslation } from 'react-i18next';
import { redirect } from '../lib/Utils';

export default function(props: RouteComponentProps<{ webToken: string }>) {
  const { success, send, response } = useService(
    useCallback(() => link(props.match.params.webToken), [
      props.match.params.webToken
    ])
  );
  const { t } = useTranslation();

  useEffect(() => {
    send();
  }, [send]);

  useEffect(() => {
    if (success && response && response.body) {
      redirect(response.body.url);
    }
  }, [success, response]);

  if (success || success === undefined) {
    return <LinearProgress color="primary" />;
  }

  if (success) {
  }

  return (
    <UPPage>
      <Typography variant="body1">{t('linkError')}</Typography>
    </UPPage>
  );
}
